import { render, staticRenderFns } from "./StockImages.vue?vue&type=template&id=0904b089&scoped=true"
import script from "./StockImages.vue?vue&type=script&lang=js"
export * from "./StockImages.vue?vue&type=script&lang=js"
import style0 from "./StockImages.vue?vue&type=style&index=0&id=0904b089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904b089",
  null
  
)

export default component.exports